/* eslint-disable */
import axios from 'axios'

const baseUrl = process.env.VUE_APP_BASE_API + "/excursion/geopoints/";


// Módulo para obtener subzones

const state = {
  geopoints: [],
  geopoint: [],
  geopointsWithoutStopScheduleAdmin: [],
  geopointsListAdmin: [],
  geopointsWithoutZoneAdmin: [],
  toggleGeopointLitAdmin: true
}

const mutations = {

  SET_POINT_WITHOUT_STOP_SCHEDULE_ADMIN(state, points) {
    state.geopointsWithoutStopScheduleAdmin = points
  },

  SET_GEOPOINTS_LIST_ADMIN(state, points) {
    state.geopointsListAdmin = points
    state.toggleGeopointLitAdmin = !state.toggleGeopointLitAdmin
  },

  SET_GEOPOINTS_LIST_WITHOUT_ZONE_ADMIN(state, points) {
    state.geopointsWithoutZoneAdmin = points
  },

  RESET_GEOPOINTS_LIST_ADMIN(state) {
    state.geopointsListAdmin = []
  },

  RESET_GEOPOINTS_WITHOUT_ZONE_ADMIN(state) {
    state.geopointsWithoutZoneAdmin = []
  }

}

const actions = {
  getGeopoints: context => {
    context.commit('GET_GEOPOINTS')
  },

  getGeopoint(context, id) {
    context.commit('GET_GEOPOINT', id)
  },

  async geoPointNotStopSchedule({
    commit, dispatch
  }, data) {
    await axios
      .get(
        baseUrl + 'not_stop_schedule/' + 
        '?suprazone_id=' + data.suprazone_id + 
        '&activity_group_id=' + data.activity_group_id
      ).then(r => r.data)
      .then(points => {
        commit('SET_POINT_WITHOUT_STOP_SCHEDULE_ADMIN', points)
      })
  },

  async getAllGeopoints(
    {
      commit, dispatch
    }, data
  ) {
    await axios
      .get(
        baseUrl + 'list_all/'
      ).then(r => r.data)
      .then(points => {
        commit('SET_GEOPOINTS_LIST_ADMIN', points)
      })
  },

  async getAllGeopointsBySuprazone(
    {
      commit, dispatch
    }, data
  ) {
    if ( data.suprazone_id > 0 ) {
      await axios
        .get(
          baseUrl + 'list_all/' + 
          '?suprazone_id=' + data.suprazone_id
        ).then(r => r.data)
        .then(points => {
          commit('SET_GEOPOINTS_LIST_ADMIN', points)
        })
    }
  },

  async getAllGeopointsWithoutAssignedZone(
    { commit, dispatch}, data
  ) {
    await axios
      .get(
        baseUrl + 'list_without_zone/'
      ).then( response => {
        commit('SET_GEOPOINTS_LIST_WITHOUT_ZONE_ADMIN', response.data)
      })
  },

  async updateGeopoint({
    commit, dispatch
  }, data) {
    await axios
      .patch(
        baseUrl + data.geopoint_id + '/',
        data.payload
      ).then(response => {
        return response.data
      })
  },

  async createGeoPoint({
    commit,  dispatch
  }, data) {
    
    await axios
      .post(
        baseUrl,
        data.payload
      ).then(response => {
        return response.data
      }

      )
  },

  async deleteGeoPoint({
    commit, dispatch
  }, data) {
    await axios
      .delete(
        baseUrl + data.id + '/'
      )
      .then(response => {
        return response.data
      })
  },

  async syncHotels({
    commit, dispatch
  }, payload) {
    let url = process.env.VUE_APP_BASE_API + '/zt/sync_hotels/'
    commit('RESET_GEOPOINTS_LIST_ADMIN')
    commit('RESET_GEOPOINTS_WITHOUT_ZONE_ADMIN')
    await axios
      .get(
        url
      )
      .then(async response => {
        // await dispatch("getAllGeopoints")
        dispatch("getAllGeopointsWithoutAssignedZone")
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
